export default __webpack_public_path__ + "static/2019_02-baed2b19fbd583955919364946c6c5a3.png";